import { Auth } from "aws-amplify";
import {
  isCordovaApp,
  cordovaFetchSiteConfig,
  cordovaFetchSiteLanguages,
  cordovaFetchPrivacyPolicy
} from "../utils/cordovaUtils";

import { bibleSource, success } from "../storage";

const baseURL = process.env.REACT_APP_SITE_API || "https://api.global.bible/";

const get = path => {
  return fetch(baseURL + path).then(response => response.json());
};

export const fetchSiteConfig = async domain => {
  if (isCordovaApp) return await cordovaFetchSiteConfig();
  const source = await bibleSource();
  const { site, status } = await source.cacheSite(domain);
  if (!success(status)) throw new Error("site not found");
  return site;
};

const put = async (path, body) => {
  const currentSession = await Auth.currentSession();
  const accessToken = currentSession.getAccessToken().getJwtToken();
  return fetch(baseURL + path, {
    method: "POST",
    headers: { Authorization: `Bearer ${accessToken}` },
    body: JSON.stringify(body)
  }).then(response => {
    if (!response.ok) {
      throw new Error(response.json());
    }
    return response.json();
  });
};

export const fetchSiteById = id =>
  get(`sites/findOne?subdomain=${id}`).then(data => data.site);

export const fetchSiteLanguages = async ({
  primaryLanguage,
  secondaryLanguage
}) => {
  if (!primaryLanguage) return;

  let requestString = `/languages/${primaryLanguage}`;
  if (secondaryLanguage)
    requestString = `${requestString}?fallbackLanguageId=${secondaryLanguage}`;

  const fetchDictionary = isCordovaApp
    ? cordovaFetchSiteLanguages()
    : get(requestString);
  const { languageDictionaries } = await fetchDictionary;

  return languageDictionaries;
};

export const fetchPolicyStatement = () => {
  return isCordovaApp
    ? cordovaFetchPrivacyPolicy()
    : fetch(`${process.env.PUBLIC_URL}/privacyPolicyStatement.json`)
        .then(response => response.json())
        .then(data => data.policy);
};

export const updateUserEmail = async updatedEmail => {
  return await put("update-email", { updatedEmail });
};
